import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { getEstimatedViewportType } from "@faire/web--source/common/user-agent/getEstimatedViewportType";
import { getWindowHeight, getWindowWidth } from "@faire/web--source/ui/hooks/useObservableWindow";
import { useCallback, useMemo, useState } from "react";
import { useHandleResize } from "./useHandleResize";
var getWindowDimension = function() {
    return {
        width: getWindowWidth(),
        height: getWindowHeight()
    };
};
export var useViewportDimension = function(deriveFromDimension) {
    var isSSR = useIsSSR();
    var initialValue = useMemo(function() {
        if (isSSR) {
            var _getEstimatedViewportType = getEstimatedViewportType(), width = _getEstimatedViewportType.width, height = _getEstimatedViewportType.height;
            return deriveFromDimension({
                width: width,
                height: height
            });
        }
        return deriveFromDimension(getWindowDimension());
    }, [
        deriveFromDimension,
        isSSR
    ]);
    var _useState = _sliced_to_array(useState(initialValue), 2), value = _useState[0], setValue = _useState[1];
    var handleResize = useCallback(function() {
        setValue(deriveFromDimension(getWindowDimension()));
    }, [
        deriveFromDimension
    ]);
    var debouncedHandleResize = useMemo(function() {
        return debounceIfPossible(handleResize, 200);
    }, [
        handleResize
    ]);
    useHandleResize(debouncedHandleResize, {
        fireImmediately: true
    });
    return value;
};
